import AddBeneficiaryError from './AddBeneficiaryError';
class CodeValidationLimitReached extends AddBeneficiaryError {
    constructor(options) {
        super('The maximum number of verification code attempts has been reached', options);
    }
}
export default CodeValidationLimitReached;
